"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const DateUtilities_1 = require("../DateUtilities");
const CreditCardUtilities_1 = require("../CreditCardUtilities");
/** @ignore This represents the statuses for a Credit Card Payment */
var CreditCardPaymentStatus;
(function (CreditCardPaymentStatus) {
    CreditCardPaymentStatus["returned"] = "Returned";
    CreditCardPaymentStatus["posted"] = "Posted";
    CreditCardPaymentStatus["pending"] = "Pending";
    CreditCardPaymentStatus["scheduled"] = "Scheduled";
    CreditCardPaymentStatus["canceled"] = "Canceled";
})(CreditCardPaymentStatus = exports.CreditCardPaymentStatus || (exports.CreditCardPaymentStatus = {}));
/** @ignore Maximum number of payments allowed to be scheduled at any given time */
const MAX_SCHEDULE_PAYMENT_COUNT = 2;
/**
 * Returns the scheduled payments for the parameterized credit card up to the maximum number allowed
 * @param payments a collection of payments on a Credit Card Account
 * @returns the first `MAX_SCHEDULE_PAYMENT_COUNT` payments after filtering for scheduled payments, and sorting it by ascending
 */
exports.scheduledPayments = ({ payments }) => payments
    .filter(payment => payment.status === CreditCardPaymentStatus.scheduled)
    .sort((first, second) => DateUtilities_1.compareAscending(first.date, second.date))
    .slice(0, MAX_SCHEDULE_PAYMENT_COUNT);
/**
 * Returns whether or not the credit card account can schedule an additional payment
 * @param creditCard a credit card account with the minimum data needed to verify whether it can schedule a payment
 * @returns `true` if the credit card was not closed, does not have a current balance, and has additional avaliable payments
 */
exports.canSchedulePayment = (creditCard) => (!creditCard.wasClosed || CreditCardUtilities_1.creditCardHasBalance(creditCard.currentBalance))
    && exports.scheduledPayments(creditCard).length < MAX_SCHEDULE_PAYMENT_COUNT;
